import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import SearchFieldSource from 'sources/triggers/SearchFieldSource';

class SearchFieldActions {
  constructor() {
    this.generateActions(...generateAsyncActions('fetchSearchFields'));
  }

  fetchSearchFields() {
    return dispatch => {
      dispatch();
      SearchFieldSource.fetchSearchFields().then(
        this.fetchSearchFieldsSuccess,
        this.fetchSearchFieldsError
      );
    };
  }
}

export default alt.createActions(SearchFieldActions);
